import { NavigationGuard } from 'vue-router';

import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';
import { FeatureFlags } from '@/types/models/FeatureFlags';

export const beforeEnterElliotService: NavigationGuard = (_to, _from, next) => {
  if (FeatureFlagsModule.isEnabled(FeatureFlags.DISABLE_ELLIOT)) {
    return next({ name: 'trade' });
  }

  next();
};
